export default __webpack_public_path__ + "static/media/video_archive_icon.e9ab7aa5.svg";